import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { withValue } from '@g4/automation-hooks';
import moment from '@g4/moment-utc';
import _ from 'lodash';

import { useTranslations } from '../../../../graphql/components/TranslationsProvider';
import { Box, Text, useMedia } from '../../../Boneyard';
import {
  GAME_TIME,
  OPPONENT_CITY,
  ROW_NUMBER,
  SEAT_NUMBER,
  SECTION_NUMBER,
} from '../../../../pageComponents/ticketsPage/constants';

const propTypes = {
  isTripSummary: PropTypes.bool,
  automationHook: PropTypes.string,
  showItem: PropTypes.array,
};

const ShowInfo = ({ automationHook, showItem, isTripSummary }) => {
  const mq = useMedia();
  const isMobile = mq.lt('md');
  const { stadiumPackages: translations } = useTranslations();

  //sort by row and seat number
  showItem?.length &&
    showItem
      .sort((a, b) => a.show.meta[SEAT_NUMBER] - b.show.meta[SEAT_NUMBER])
      .sort((a, b) => a.show.meta[ROW_NUMBER] - b.show.meta[ROW_NUMBER]);

  return (
    <Box d="inline">
      <Box pl={2} pb={1} d="flex" justifyContent="space-between">
        <Text
          size={isMobile ? 15 : 17}
          weight={600}
          automationHook={withValue(automationHook, 'game-name')}
        >
          {_.startCase(showItem?.[0]?.show.meta[OPPONENT_CITY]) +
            ' ' +
            translations.versusLabel +
            ' ' +
            translations.homeCityLabel}
        </Text>
      </Box>

      <Box pl={2} pb={1} d="flex" justifyContent="space-between">
        <Text
          size={isTripSummary ? 16 : 14}
          weight={500}
          automationHook={withValue(automationHook, 'game-day')}
        >
          {moment(showItem?.[0]?.show.date).format('ddd, MMM D,') +
            ' ' +
            showItem?.[0]?.show.meta[GAME_TIME]}
        </Text>
      </Box>

      <Box pl={2} d="flex" justifyContent="space-between">
        <Text
          size={isTripSummary ? 16 : 14}
          weight={500}
          automationHook={withValue(automationHook, 'ticket-tier')}
        >
          {`Section ${showItem?.[0]?.show.meta[SECTION_NUMBER]} -
            ${showItem?.map(
              seat =>
                ' ' +
                'Row' +
                seat.show.meta[ROW_NUMBER] +
                '-Seat' +
                seat.show.meta[SEAT_NUMBER]
            )}`}
        </Text>
      </Box>
    </Box>
  );
};

ShowInfo.propTypes = propTypes;

export default withTheme(ShowInfo);
